import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { environment } from '../../../environments/environment';
import { Http, Response, RequestOptions, Headers } from "@angular/http";
import { LocalStorageService } from '../../services/shared/localStorage.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NotificationComponent } from '../shared/notification.component';
import { LookupService } from '../../services/lookups/lookup.service';
import { UserAgreementService } from '../../services/lookups/user-agreement.service';

@Component({
  selector: 'app-terms-of-service',
  templateUrl: './terms-of-service.component.html',
  styleUrls: ['./terms-of-service.component.css'],
  encapsulation: ViewEncapsulation.None,

})
export class TermsOfServiceComponent {

  constructor(private authService: AuthService,
              private router: Router,
              private uas: UserAgreementService
  ) {}

  onUserAgreementLoaded: Subscription;

  loading: boolean = false;
  isTermsOfServiceAccepted: boolean = false;
  termsOfServiceHTML;

  ngOnInit() {
    this.isTermsOfServiceAccepted = this.authService.getUser().isAgreed;

    this.uas.load();

    this.onUserAgreementLoaded = this.uas.userAgreementLoaded
      .subscribe(
        (response: any) => {
          this.termsOfServiceHTML = this.uas.getUserAgreement().userAgreementContent;
        });
  }


  logOutUser() {
    this.authService.logout();
  }

  acceptTermsOfService() {
    this.authService.agreeToTermsOfService()
    this.loading = true;
  }
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/components/anon/terms-of-service.component.ts